'use strict';
var BASWebServices;
(function (BASWebServices) {
    var MessageBoxTypeFilter = (function () {
        function MessageBoxTypeFilter() {
        }
        MessageBoxTypeFilter.Factory = function () {
            return function (input, showSuccess, showWarning, showError) {
                return input.filter(function (x) {
                    switch (x.getType().toLowerCase()) {
                        case "success": return showSuccess;
                        case "warning": return showWarning;
                        case "success (+warning)": return showWarning;
                        case "error": return showError;
                        default: return true;
                    }
                });
            };
        };
        return MessageBoxTypeFilter;
    }());
    BASWebServices.MessageBoxTypeFilter = MessageBoxTypeFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=MessageBoxTypeFilter.js.map